<template>
    <div class="truncated-text" :class="{ 'read-more': readMore }">
        <div class="content-wrapper" :style="{ maxHeight: readMore ? contentHeight + 'px' : minHeight + 'px' }">
          <p ref="contentBox" v-html="content"></p>
        </div>
        <button v-if="minHeight < contentHeight" class="toggle-button" type="button" @click.prevent="toggleReadMore">
            Show {{ readMore ? 'less' : 'more' }}
        </button>
    </div>
</template>
  
<script>
import { ref, onMounted} from 'vue';

export default {
    setup(props) {
        const readMore = ref(false);
        const minHeight = ref(140);
        const contentHeight = ref(0);
        const content = ref(props.content);
        const contentBox = ref(null);

        onMounted(() => {
          calculateContentHeight();
        });

        const calculateContentHeight = () => {
            if (contentBox.value) {
              contentHeight.value = contentBox.value.clientHeight;
            }
        };

        const toggleReadMore = () => {
          readMore.value = !readMore.value;
          if (readMore.value) {
            calculateContentHeight();
          }
        };
        
        return {
          readMore,
          contentHeight,
          minHeight,
          content,
          toggleReadMore,
          contentBox
        };
    },
    props: {
      content: {
        type: String,
        required: true,
        default: '',
      },
    }
  }
  </script>